import { create } from "zustand";
import { ZOOM_ATTENDANCE_CONSTANTS } from "../constants/ZoomAttendance.constants";

export const useSessionParticipantsStore = create((set) => ({
  activeTab: ZOOM_ATTENDANCE_CONSTANTS.TAB_VALUES.ALL,
  filterValues: {},
  isUnrecognizedView: false,

  setActiveTab: (tab) => set({ activeTab: tab }),

  setFilterValues: (filters = {}) => {
    const attendanceType = filters?.attendance_type;
    const isUnrecognized =
      Number(attendanceType) ===
        ZOOM_ATTENDANCE_CONSTANTS.PARTICIPANT_ATTENDANCE_TYPES.UNRECOGNIZED ||
      attendanceType ===
        ZOOM_ATTENDANCE_CONSTANTS.PARTICIPANT_ATTENDANCE_TYPES.UNRECOGNIZED ||
      attendanceType === ZOOM_ATTENDANCE_CONSTANTS.TAB_VALUES.UNRECOGNIZED;

    set((state) => {
      if (
        JSON.stringify(state.filterValues) === JSON.stringify(filters) &&
        state.isUnrecognizedView === isUnrecognized
      ) {
        return state;
      }
      return { filterValues: filters, isUnrecognizedView: isUnrecognized };
    });
  },

  setIsUnrecognizedView: (val) => set({ isUnrecognizedView: val }),

  resetStore: () =>
    set({
      activeTab: ZOOM_ATTENDANCE_CONSTANTS.TAB_VALUES.ALL,
      filterValues: {},
      isUnrecognizedView: false,
    }),
}));
